import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Element } from '../html/element'

export const Cell = ({
  colId,
  getDataFromRedux,
  rowId,
  rowIndex,
  render,
  renderCustom,
  tdStyle,
  sticky,
  isHovered,
  isSelected,
}) => {
  const data = useSelector(getDataFromRedux(rowId, colId))
  const locale = useSelector((state) => state.i18n.locale)

  const getStyle = () => {
    const isEvenRow = rowIndex % 2 === 0

    const style = {
      color: '#3A414B',
      backgroundColor: isSelected
        ? '#C8E3FF'
        : isHovered
        ? '#EDF5FE'
        : isEvenRow
        ? '#F9F9F9'
        : '#FFFFFF',
    }

    if (sticky) {
      style.left = 0
      style.zIndex = 1
      style.position = 'sticky'
    }

    const customTdStyle =
      typeof tdStyle === 'function'
        ? tdStyle({ isHovered, isEvenRow })
        : tdStyle

    return { ...style, ...customTdStyle }
  }

  const renderContent = () => {
    return render
      ? render(data, { rowId, isHovered, rowIndex, locale, colId })
      : data
  }

  if (renderCustom) {
    return renderCustom(data, {
      rowId,
      isHovered,
      rowIndex,
      locale,
      getStyle,
      colId,
    })
  }

  return (
    <Element elementName="td" style={getStyle()}>
      {renderContent()}
    </Element>
  )
}

Cell.propTypes = {
  colId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  getDataFromRedux: PropTypes.func.isRequired,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  rowIndex: PropTypes.number.isRequired,
  isHovered: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
  render: PropTypes.func,
  tdStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  sticky: PropTypes.bool,
}

Cell.defaultProps = {
  tdStyle: {},
  sticky: false,
  isSelected: false,
}
